import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getMessage } from "CONFIG/i18n";
import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

// WebSocket
import { sendWebsocketMessage } from "WEBSOCKET/SupportCenterWebsocketHandler";
import { socketMessage } from "WEBSOCKET/constants";

// components
import Spinner from "COMPONENTS/Spinner/Spinner";
import { selectIsSnapShotRunning, getIsScreenMasking } from "REDUX/Selector/SessionSelector";
import { inboundCoBrowseAction, sessionActions } from "CONFIG/ActionFactory";
import InboundCoBrowse from "./InboundCoBrowse";

// Actions
import { headerAction } from "CONFIG/ActionFactory";

// UTILS
import { COMPONENT_IN_FOCUS } from "UTILS/Constants";

// selector
import { getShowInboundCoBrowse, setEndInboundCoBrowse, setIsInboundCobrowseMinimize } from "./InboundCoBrowseSelector";
import { getShowAudioVideoComponentFlag } from "COMPONENTS/Dashboard/selectors"

class InboundCoBrowseContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageData: null,
    };
    this.isComponentMounted = false;
  }

  componentDidMount() {
    this.isComponentMounted = true;
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  setMessageDataSafely = (messageData) => {
    if (this.isComponentMounted) {
      this.setState({ messageData });
    }
  }

  cleanupInboundCoBrowseOnError = async () => {
    sessionActions.setComponentInFocus(this.props.showAudioVideoComponent ? COMPONENT_IN_FOCUS.AUDIO_VIDEO : COMPONENT_IN_FOCUS.CANVAS);
    inboundCoBrowseAction.isInboundCoBrowseMinimize(false);

    try {
      await inboundCoBrowseAction.endInboundCoBrowse(true, this.props.sessionKey);
    } catch (cleanupError) {
      console.error('Failed to cleanup inbound cobrowse session', cleanupError);
    } finally {
      inboundCoBrowseAction.showHideInboundCoBrowse(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.componentInFocus !== this.props.componentInFocus) {
      if (this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE) {
        this.handleStartInboundCoBrowseSessionClick();
      }
      if(this.props.componentInFocus !== COMPONENT_IN_FOCUS.CANVAS){
        this.props.setValue("isZoomOut", true)
      } else {
        this.props.setValue("isZoomOut", false)
      }
    }
  }

  handleStartInboundCoBrowseSessionClick = async () => {
    const requestData = {
      sessionKey: this.props.sessionKey,
    };
    let data = await inboundCoBrowseAction.getInboundCobrowseCredentials(requestData).then(
      (response) => {
        inboundCoBrowseAction.showHideInboundCoBrowse(true);
        return response;
      },
      async (error) => {
        console.error(error);
        const errorCode = error?.code || "INTERNAL_SERVER_ERROR";
        toastr.error(getMessage(errorCode));
        await this.cleanupInboundCoBrowseOnError();
        return null;
      }
    );

    if (!this.isComponentMounted || !data) {
      return;
    }

    // Ensure data.status is checked safely
    const status = data?.status ?? 0; // Default to 0 if undefined

    if (status === 200) {
      data = data.data.data; // filter response data

      const message = {
        data: {
          // category: socketMessage.category.INBOUND_CO_BROWSE,
          // action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.PERMISSION_REQUEST,
          api: data.api, 
          sessionKey: data.sessionKey,
          token: data.token,
        }
      };

      // Set message data
      this.setMessageDataSafely(message.data);
      // this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    } 
  }

  render() {
    return (
      this.state.messageData ? 
        <InboundCoBrowse 
          data={this.state.messageData}
          endInboundCoBrowse={this.props.endInboundCoBrowse}
          isInboundCobrowseMinimize={this.props.isInboundCobrowseMinimize}
          showInboundCoBrowse={this.props.showInboundCoBrowse}
          setComponentInFocus={this.props.setComponentInFocus}
          showAudioVideoComponent={this.props.showAudioVideoComponent}
          sessionKey={this.props.sessionKey}
          componentInFocus={this.props.componentInFocus}
          isScreenShare={this.props.isScreenShare}
        />
        : null
    );
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.SessionReducer.sessionDetails.token,
    customerUriIdentifier: state.OrganisationReducer.customerData.uri_identifier,
    sessionName: state.SessionReducer.sessionDetails.sessionName,
    sessionKey: state.SessionReducer.sessionDetails.sessionKey,
    uniqueId: state.SessionReducer.uniqueId,
    role: state.UserReducer.userDetails.role,
    sessionType: state.SessionReducer.sessionSubType,
    endInboundCoBrowse: setEndInboundCoBrowse(state),
    showInboundCoBrowse: getShowInboundCoBrowse(state),
    isSnapshotRunning: selectIsSnapShotRunning(state),
    isScreenMasking: getIsScreenMasking(state),
    showAudioVideoComponent: getShowAudioVideoComponentFlag(state)
  };
};

export default withErrorHandler(connect(
  mapStateToProps,
)(InboundCoBrowseContainer));
